import { createSlice } from "@reduxjs/toolkit";

import { DEMO_EMAIL } from "appConstants";
import CustomerModel from "models/CustomerModel";
import { getCustomerById, getOemDropDown } from "services/customer.service";

import { RootState } from "store/store";
import DropDownModel from "models/DropDownModel";

interface ICustomerState {
    oemDropDown: DropDownModel[];
    selectedCustomer?: CustomerModel | null;
    loading: boolean;
}

export const initialCustomer: CustomerModel = {
    customerId: "",
}

const initialState: ICustomerState = {
    oemDropDown: [],
    loading: false,
    selectedCustomer: null
}

const demoCustomer: CustomerModel = {
    customerId: "001",
    name: "Demo",
    email: DEMO_EMAIL,
    primaryColor: "#002855",
    secondaryColor: "#0057B8",
    primaryForeground: "#ffffff",
    secondaryForeground: "#ffffff"
} 

export const customersSlice = createSlice({
    name: "customers",
    initialState,
    reducers: {
        setDemoCustomer: (state) => {
            state.selectedCustomer = demoCustomer;
        },
        clearCustomer: (state) => {
            state.oemDropDown = [];
            state.loading = false;
            state.selectedCustomer = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOemDropDown.fulfilled, (state, action) => {
                state.oemDropDown = action.payload;
                state.loading = false;
            })
            .addCase(getOemDropDown.pending, (state) => {
                state.loading = true;
            })
            .addCase(getOemDropDown.rejected, (state) => {
                state.loading = false;
            })
            .addCase(getCustomerById.fulfilled, (state, action) => {
                state.selectedCustomer = action.payload;
                state.loading = false;
            })
            .addCase(getCustomerById.pending, (state) => {
                state.loading = true;
            })
            .addCase(getCustomerById.rejected, (state) => {
                state.loading = false;
            })
    }
});

export const { setDemoCustomer, clearCustomer } = customersSlice.actions;
export const selectOemDropDown = (state: RootState) => state.customers.oemDropDown;
export const customersReducer = customersSlice.reducer;